import { gql } from '@apollo/client';

const query = gql`
  query searchSeoSuburb($params: JSONObject) {
    searchSeoSuburb(params: $params)
  }
`;

module.exports = query;
